<template>
    <CRow>
        <CCol col=12>
            <CCard>
                <CCardHeader class="pb-0">
                    <CRow form class="form-group">
                        <CCol sm="12">
                            <CForm inline>
                                <label class="col-form-label ml-2 mr-2" style="min-width: 55px; display: block">입력 방식 :
                                </label>
                                <CInputRadioGroup inline :checked.sync="inputType" :options="[
                                    { value: 'excel', label: 'Excel 입력'},
                                    { value: 'input', label: '직접 입력'}
                                ]" custom />
                            </CForm>
                        </CCol>
                    </CRow>
                </CCardHeader>
                <CCardBody class="p-2">
                    <CRow>
                        <CCol col=12>
                            <CRow v-if="inputType == 'excel'" form class="form-group">
                                <CCol lg=12 md=12 sm="12">
                                    <CForm inline>
                                        <CCol lg=4 md=6 sm=12 class="form-inline">
                                            <label class="col-form-label ml-2 mr-1"
                                                style="min-width: 55px; display: block">파일 입력 :
                                            </label>
                                            <CInputFile ref="inputFile"
                                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                                            <CButton key="info" @click="UploadFile" color="info" shape="pill"
                                                class="m-2">
                                                파일 업로드
                                            </CButton>
                                        </CCol>
                                        <CCol lg=5 md=6 sm=12 class="form-inline">
                                            <label class="col-form-label mr-2">
                                                농가 정보 :
                                            </label>
                                            <div role="group" class="form-group w-50 form-inline">
                                                <CSelect :value.sync="app.facilityId" ref="facility"
                                                    :options="app.facilityList">
                                                </CSelect>
                                                <CSelect :value.sync="inFacilityId" ref="infacility"
                                                    :options="inFacilityList">
                                                </CSelect>
                                            </div>
                                        </CCol>
                                    </CForm>


                                </CCol>
                            </CRow>
                            <CRow v-if="inputType == 'input'" form class="form-group">
                                <CCol sm="12" lg=12 md=12>
                                    <div style="border-bottom: 1px solid black;">
                                        <CForm inline class="mb-3">
                                            <CCol lg=6 md=6 sm=12 class="form-inline">
                                                <label class="col-form-label mr-2">
                                                    농가 정보 :
                                                </label>
                                                <div role="group" class="form-group w-50 form-inline">
                                                    <CSelect :value.sync="app.facilityId" ref="facility"
                                                        :options="app.facilityList">
                                                    </CSelect>
                                                    <CSelect :value.sync="inFacilityId" ref="infacility"
                                                        :options="inFacilityList">
                                                    </CSelect>
                                                </div>
                                            </CCol>
                                            <CCol lg=6 md=6 sm=12 class="form-inline">
                                                <label class="col-form-label mr-2">측정 날짜 :
                                                </label>
                                                <div role="group" class="form-group form-inline">
                                                    <v-date-picker v-model="input_item.growth_Date" mode="dateTime"
                                                        is24hr :masks="{ title: 'YYYY년 MMM', L: 'YYYY-MM-DD' }"
                                                        class="w-100">
                                                        <template v-slot="{ inputValue, inputEvents }">
                                                            <div class="flex justify-center items-center">
                                                                <input :value.sync="input_item.growth_Date"
                                                                    :value="inputValue" v-on="inputEvents"
                                                                    class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300" />
                                                            </div>
                                                        </template>
                                                    </v-date-picker>
                                                </div>
                                            </CCol>
                                        </CForm>
                                    </div>
                                    <CRow>
                                        <CCol sm=12 md=6 lg=6>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">샘플 번호 :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.sample_ID" type="number" />
                                                </div>
                                            </CForm>
                                        </CCol>
                                        <CCol sm=12 md=6 lg=6>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">주차 :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.week" type="number" />
                                                </div>
                                            </CForm>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol sm=12 lg=6 md=6>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">초장(cm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.plant_Length" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">옆수 :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.leff_Count" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">옆장(cm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.leaf_Length" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">옆폭(cm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.leaf_Width" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">절간장(cm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.internode_Length" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">특이사항 :
                                                </label>
                                                <textarea class="form-control w-75" v-model="input_item.etc"
                                                    :style="etc_style" rows="3"></textarea>
                                            </CForm>
                                        </CCol>
                                        <CCol sm=12 lg=6 md=6>

                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">꽃 핀 화방 수(개) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.flower_Cluster" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">꽃 핀 화방 길이(cm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.flower_Length" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">꽃 핀 화방 경경(mm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.stem_Diameter" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">마지막 화방 수(개) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.last_flower_Cluster"
                                                        type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">마지막 화방 길이(cm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.last_flower_Length" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">마지막 화방 경경(mm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.last_stem_Diameter" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">화방별
                                                    꽃수(개/화방) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.flower_Number"
                                                        placeholder="개/화방, 개/화방" type="text" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">생장점과 꽃핀
                                                    화방거리(cm) :
                                                </label>
                                                <div role="group"
                                                    class="form-group form-row ml-2 mt-sm-auto w-1 w-auto-sm">
                                                    <CInput :value.sync="input_item.growth_Point" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">화방간
                                                    거리(cm) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.room_Distance" type="number" />
                                                </div>
                                            </CForm>
                                            <CForm class="m-1 mb-2" inline>
                                                <label class="col-form-label ml-2 mr-2"
                                                    style="min-width: 55px; display: block">착과수(개/화방) :
                                                </label>
                                                <div role="group" class="form-group form-row ml-2"
                                                    v-bind:class="{'mt-2':!isMobile,'mt-4':isMobile}">
                                                    <CInput :value.sync="input_item.fruit_Count"
                                                        placeholder="개/화방, 개/화방" type="text" />
                                                </div>
                                            </CForm>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol col=12>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter v-if="inputType == 'input'">
                    <CButton key="info" color="info" shape="pill" class="m-2 float-right" @click="Input_Data()">
                        입력하기
                    </CButton>
                </CCardFooter>
            </CCard>
            <CCard>
                <CCardBody class="p-2">
                    <CRow form class="form-group">
                        <CCol sm="12">
                            <CDataTable class="table-bordered" style="overflow-x:scroll;" :items="items"
                                :fields="fields" items-per-page-select :items-per-page="5" hover sorter pagination
                                @row-clicked="UpdateData">
                                <template #show_details="{item, index}">
                                    <td class="py-2">
                                        <CButton color="warning" @click="remove_Item(index)" square size="sm">
                                            <CIcon name="cil-trash"></CIcon>
                                        </CButton>
                                    </td>
                                </template>
                            </CDataTable>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CRow>
                        <CCol col="12">
                            <CButton key="info" @click="SendData" color="info" shape="pill" class="m-2 float-right">
                                저장하기
                            </CButton>
                        </CCol>
                    </CRow>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>
<script>
    import axios from "axios";
    import XLSX from "xlsx";
    import core from "@/core";
    import MixinsInFacility from "@/mixins/in-facility";
    import store from "@/store";

    export default {
        name: "GrowthInformationInput",
        components: {},
        mixins: [MixinsInFacility()],
        data() {
            return {
                etc_style: null,
                inFacilityId: 0,
                inputType: "input",
                isMobile: false,
                fields: [
                    {
                        label: '시설ID',
                        _style: 'width:5%', key: "facility_ID"
                    },
                    {
                        label: '내부 시설ID',
                        _style: 'width:5%', key: "inFacility_ID"
                    },
                    {
                        label: '날짜',
                        _style: 'width:10%', key: "growth_Date"
                    },
                    {
                        label: '주차',
                        _style: 'width:4%', key: "week"
                    },
                    {
                        label: '샘플 ID',
                        _style: 'width:5%', key: "sample_ID"
                    },
                    {
                        label: '초장(cm) :',
                        _style: 'width:5%', key: "plant_Length"
                    },
                    {
                        label: '옆수 :',
                        _style: 'width:6%', key: "leff_Count"
                    },
                    {
                        label: '옆장(cm) :',
                        _style: 'width:5%', key: "leaf_Length"
                    },
                    {
                        label: '옆폭(cm) :',
                        _style: 'width:5%', key: "leaf_Width"
                    },
                    {
                        label: '절간장(cm) :',
                        _style: 'width:5%', key: "internode_Length"
                    },
                    {
                        label: '꽃 핀 화방 경경(mm) :',
                        _style: 'width:5%', key: "stem_Diameter"
                    },
                    {
                        label: '꽃 핀 화방 수(번째) :',
                        _style: 'width:8%', key: "flower_Cluster"
                    },
                    {
                        label: '꽃 핀 화방 길이(cm) :',
                        _style: 'width:8%', key: "flower_Length"
                    },
                    {
                        label: '마지막 화방 경경(mm) :',
                        _style: 'width:8%', key: "last_stem_Diameter"
                    },
                    {
                        label: '마지막 화방 수(번째) :',
                        _style: 'width:8%', key: "last_flower_Cluster"
                    },
                    {
                        label: '마지막 화방 길이(cm) :',
                        _style: 'width:8%', key: "last_flower_Length"
                    },
                    {
                        label: '화방별 꽃수(개/화방) :',
                        _style: 'width:8%', key: "flower_Number"
                    },
                    {
                        label: '생장점과 꽃핀 화방거리(cm) :',
                        _style: 'width:10%', key: "growth_Point"
                    },
                    {
                        label: '화방간 거리(cm) :',
                        _style: 'width:8%', key: "room_Distance"
                    },
                    {
                        label: '착과수(개/화방) :',
                        _style: 'width:8%', key: "fruit_Count"
                    },
                    {
                        key: 'show_details',
                        label: '',
                        _style: 'width:5%',
                        sorter: false,
                        filter: false
                    }
                ], items: [
                ],
                input_item: {
                    facility_ID: null,
                    inFacility_ID: null,
                    growth_Date: new Date(),
                    week: null,
                    sample_ID: null,
                    plant_Length: null,
                    leff_Count: null,
                    leaf_Length: null,
                    leaf_Width: null,
                    internode_Length: null,
                    stem_Diameter: null,
                    flower_Cluster: null,
                    flower_Length: null,
                    flower_Number: null,
                    growth_Point: null,
                    room_Distance: null,
                    fruit_Count: null,
                    last_stem_Diameter: null,
                    last_flower_Cluster: null,
                    last_flower_Length: null,
                    etc: null,
                },
                data_update: false,
                data_col: null,
            }
        },
        mounted() {
            this.isMobile = window.innerWidth < 768;

            if (window.innerWidth > 768) {
                this.etc_style = { height: "20vh" }
            } else {
                this.etc_style = null;
            }
            window.addEventListener('resize', () => {
                this.isMobile = window.innerWidth < 768;
                if (window.innerWidth > 768) {
                    this.etc_style = { height: "20vh" }
                } else {
                    this.etc_style = null;
                }
            })
        },
        methods: {
            async division(n) {
                var len = this.items.length;
                var cnt = Math.floor(len / n);
                var tmp = [];

                for (var i = 0; i <= cnt; i++) {
                    tmp.push(this.items.splice(0, n));
                }

                return tmp;
            },
            remove_Item(index) {
                this.items.splice(index, 1);
            },
            async Input_Data() {
                if (this.data_update) {
                    this.items[this.data_col] = this.input_item;
                    this.data_update = false;
                    this.data_col = null;
                } else {
                    await (this.inputData());
                }

                this.input_item = await (this.ClearData())
            },
            async inputData() {
                this.input_item.facility_ID = this.$refs.facility.value;
                this.input_item.inFacility_ID = this.$refs.infacility.value;
                this.items.push(this.input_item);

                return true;
            },
            async ClearData() {
                return {
                    facility_ID: null,
                    inFacility_ID: null,
                    growth_Date: new Date(),
                    week: null,
                    sample_ID: null,
                    plant_Length: null,
                    leff_Count: null,
                    leaf_Length: null,
                    leaf_Width: null,
                    internode_Length: null,
                    stem_Diameter: null,
                    flower_Cluster: null,
                    flower_Length: null,
                    flower_Number: null,
                    growth_Point: null,
                    room_Distance: null,
                    fruit_Count: null,
                    last_stem_Diameter: null,
                    last_flower_Cluster: null,
                    last_flower_Length: null,
                    etc: null,
                }
            },
            UpdateData(item, index, column, event) {
                this.input_item = item;
                this.data_update = true;
                this.data_col = column;
            },
            async SendData() {
                const timer = ms => new Promise(res => setTimeout(res,ms));
                var sd = await this.division(200); 
                sd.forEach(async (v)=>{
                    console.log(v);
                    axios.post("/db/Save_Growth",{data:v});
                    await timer(1000);
                })
            },
            async dateFormat(dt) {
                async function zeroplus(value) {
                    return value < 10 ? "0" + value : value;
                }
                var yyyy = await zeroplus(dt.getFullYear());
                var MM = await zeroplus(dt.getMonth() + 1);
                var dd = await zeroplus(dt.getDate());
                var HH = await zeroplus(dt.getHours());
                var mm = await zeroplus(dt.getMinutes());
                var ss = await zeroplus(dt.getSeconds());
                return yyyy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss
            },
            async data_null(data,key){
                return (data[key] == undefined || data[key].trim() == '' ) ? null : data[key].trim();
            },
            async UploadFile(event) {
                var file = this.$refs.inputFile._data.state[0];
                var fileName = file.name;

                const reader = new FileReader();
                let tmpResult = {};

                reader.onload = async (e) => {
                    let data = e.target.result;
                    data = new Uint8Array(data);
                    let excelFile = XLSX.read(data, { type: "array" })
                    const roa = XLSX.utils.sheet_to_json(
                        excelFile.Sheets["생육데이터"],
                        { header: 0, raw: false }
                    );

                    console.log(roa);
                    roa.forEach(async (val, ind) => {
                        var temp_Date = val["date"].split("/");
                        this.items.push({
                            facility_ID: this.$refs.facility.value,
                            inFacility_ID: this.$refs.infacility.value,
                            growth_Date: await this.dateFormat(new Date("20" + temp_Date[2] + "/" + temp_Date[0] + "/" + temp_Date[1])),
                            sample_ID: val["Sample"],
                            week: val["week"],
                            plant_Length: await this.data_null(val,"초장"), 
                            leff_Count: await this.data_null(val,"Leaf_number"),
                            leaf_Length: await this.data_null(val,"Leaf_length"),
                            leaf_Width: await this.data_null(val,"Leaf_width"),
                            internode_Length: await this.data_null(val,"절간장"),
                            stem_Diameter: await this.data_null(val,"꽃핀화방줄기두께"),
                            flower_Cluster: await this.data_null(val,"꽃핀화방수"),
                            flower_Length: await this.data_null(val,"꽃핀화방길이"),
                            flower_Number: await this.data_null(val,"화방별 꽃수"),
                            growth_Point: await this.data_null(val,"Growth_length"),
                            room_Distance: null,
                            fruit_Count: await this.data_null(val,"화방별 착과수"),
                            last_stem_Diameter: await this.data_null(val,"마지막화방줄기두께"),
                            last_flower_Cluster: await this.data_null(val,"마지막화방수"),
                            last_flower_Length: await this.data_null(val,"마지막화방길이"),
                            etc: await this.data_null(val,"비고"),
                        })
                    })
                    console.log(roa);
                }
                reader.readAsArrayBuffer(file);

            }
        }
    };
</script>